import { Component, OnInit } from '@angular/core';
import { Pagelist } from '@maced/angular-components/lib/page-list/page-list.interface';
import { DropdownOption } from '@maced/angular-components/lib/dropdown/dropdown.model';

interface PinnedPagelist extends Pagelist {
  showLeftBorder?: boolean;
  showImage?: boolean;
  imageUrl?: string;
  imageClass?: string;
  imageText?: string;
  imageAlt?: string;
  imageStyleClass?: string;
  imagePosition?: 'left' | 'right';
  borderPosition?: 'left' | 'right';
  dropdownPosition?: 'left' | 'right';
  styleClass?: string[];
}

@Component({
  selector: 'app-page-list',
  templateUrl: './page-list.component.html',
  styleUrls: ['./page-list.component.scss']
})
export class PagelistComponent implements OnInit {

  pagelistItems: Pagelist[] = []; 
  pagelistItems1: Pagelist[] = [];
  pagelistItems2: Pagelist[] = [];
  pageListUseCases: PinnedPagelist[][] = [];

  pagelistId = 'PagelistContainer1';
  pagelistId2 = 'PagelistContainer2';
  showVeritcal: boolean = false;
  showHorizontal: boolean = true;
  options4: DropdownOption[] = [
    {
      id: 'option41',
      name: 'option41',
      label: 'option 41',
      url: '/dropdown'
    },
    {
      id: 'option42',
      name: 'option42',
      label: 'option 42',
      url: '/dropdown'
    },
    {
      id: 'option43',
      name: 'option43',
      label: 'option 43',
      url: '/dropdown',
      icon: 'icon-user-circle',
      disabled: true
    }
  ];
  selectedOptions4!: DropdownOption;

  constructor() { }

  ngOnInit(): void {
    this.pagelistItems = [
      {
        id: '1', name: 'Page list Item 1', details: 'This is Description with link', detailsTargetUrl: '/card', showNotificationIconOnLeft: false, label: 'Page list Item with Link 1', subLabel: 'This is Sub Level with Link', subLinkTargetUrl: '/toast', isDisabled: false, isActive: false, targetUrl: '/button', dropdownData: this.options4, hasDropdown:true, dropdownSelectedOptions: this.selectedOptions4,contentId: 'contentId',
        contentAriaLable: 'contentAriaLable'
      },
      {
        id: '2', name: 'Page list Item Without Anchor 2', details: 'This is Description without link', detailsTargetUrl: '', showNotificationIconOnLeft: false, label: 'Page list Item without Link 2', subLabel: 'This is Sub Level without Link', subLinkTargetUrl: '', isDisabled: false, isActive: false, targetUrl: '', dropdownData: this.options4, hasDropdown:true, dropdownSelectedOptions: this.selectedOptions4
      },
      {
        id: '3', name: 'Page list Item 3', details: 'यह विवरण है', detailsTargetUrl: '/card', showNotificationIconOnLeft: false, label: 'लिंक के बिना सूची आइटम 3', subLabel: 'This is Sub Level with Link', subLinkTargetUrl: '/button', isDisabled: false, isActive: false, targetUrl: ''
      },
      {
        id: '4', name: 'Page list Item 4', details: 'Esta es la descripción', detailsTargetUrl: '/card', showNotificationIconOnLeft: false, label: 'Elemento de lista 4', subLabel: 'This is Sub Level without Link', subLinkTargetUrl: '', isDisabled: false, isActive: false, targetUrl: '/button'
      },
      {
        id: '5', name: 'Page list Item 5', details: '', detailsTargetUrl: '/card', iconName: 'status icon', iconClass: 'icon-message-dots-circle', showIcon: true, label: 'Page list Item 5', subLabel: 'Elemento de lista', subLinkTargetUrl: '/card', isDisabled: false, isActive: true, targetUrl: '/button'
      },
      {
        id: '6', name: 'Page list Item 6', details: '', detailsTargetUrl: '/card', showNotificationIconOnLeft: true, label: 'Page list Item 6', subLabel: 'सूची आइटम', subLinkTargetUrl: '/card', isDisabled: false, isActive: false, targetUrl: '/card'
      },
      {
        id: '7', name: 'Page list Item 7', details: 'This is Description', detailsTargetUrl: '/card', iconName: 'status icon', iconClass: 'icon-lms-dashboard', showIcon: true, showNotificationIconOnLeft: true, label: 'Page list Item 7 with Notification', subLabel: 'This is sub level link', subLinkTargetUrl: '/card', showNotification: true, notificationColor: 'red', isDisabled: false, isActive: false, targetUrl: '/card'
      },
      {
        id: '8', name: 'Page list Item 8', details: 'This is Description', detailsTargetUrl: '/card',  iconName: 'status icon', iconClass: 'icon-lms-dashboard', showIcon: true, showNotificationIconOnLeft: false, label: 'Page list Item 8 with Notification', subLabel: 'This is sub level link', subLinkTargetUrl: '/button', showNotification: true, notificationColor: 'green', isDisabled: true, isActive: false, targetUrl: '/toast'
      },
      {
        id: '9', name: 'Page list Item 9', details: 'This is Description', detailsTargetUrl: '/card',  iconName: 'status icon', iconClass: 'icon-lms-dashboard', showIcon: true, showNotificationIconOnLeft: true, label: 'Page list Item 9 with Notification', subLabel: 'This is sub level link', subLinkTargetUrl: '/button', showNotification: true, notificationColor: 'blue', isDisabled: false, isActive: true, targetUrl: '/toast'
      }
    ];
    const baseDesignItem: PinnedPagelist = {
        id: 'pinned-quiz',
        name: 'Pinned quiz',
        label: 'Lost for words quiz',
        details: 'Page 2-3',
        isDisabled: false,
        showImage: true,
        imageClass: 'c-page-list__pin',
        imageAlt: 'Pinned',
        imageStyleClass: 'c-page-list__item-image--accent-orange',
        showLeftBorder: true,
        styleClass: ['c-page-list__item--design-card', 'c-page-list__item--accent-orange'],
        dropdownData: this.options4,
        dropdownSelectedOptions: this.selectedOptions4
    };
    this.pageListUseCases = [
      [{
        ...baseDesignItem,
        id: 'pin-left-border-left',
        imagePosition: 'left',
        borderPosition: 'left',
        hasDropdown: true,
        dropdownPosition: 'right'
      }],
      [{
        ...baseDesignItem,
        id: 'pin-right-border-right',
        imagePosition: 'right',
        borderPosition: 'right',
        hasDropdown: true,
        dropdownPosition: 'right'
      }],
      [{
        ...baseDesignItem,
        id: 'pin-right-border-left',
        imagePosition: 'right',
        imageStyleClass: 'c-page-list__item-image--accent-blue',
        borderPosition: 'left',
        styleClass: ['c-page-list__item--design-card', 'c-page-list__item--accent-blue'],
        hasDropdown: false
      }]
    ];
  }

}
